import { Box, Grid, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { AddOnItemName } from "schemas/dashboard";

import styles from "./styles";

interface Props {
  checkoutAddOn: (addOnItem: AddOnItemName) => void;
  selectedPlan: AddOnItemName | null;
  setSelectedPlan: Dispatch<SetStateAction<AddOnItemName | null>>;
}

const ProgramInfo = ({
  checkoutAddOn,
  selectedPlan,
  setSelectedPlan,
}: Props) => {
  return (
    <Box sx={{ my: 3, px: { xs: 2, md: 6, lg: 10 } }}>
      <Grid>
        <Typography
          sx={styles.header}
          textAlign="center"
          component="div"
          gutterBottom
        >
          <strong>Q4 Repitching Offer: High-Touch, Human Follow-Ups</strong>
        </Typography>
        <Typography textAlign="center" variant="h6">
          Secure repeat brand deals before BFCM with personalized follow-ups
          written by real humans.
        </Typography>
        <Typography sx={{ mt: 2 }}>
          The best Q4 deals don't come from cold outreach — they come from{" "}
          <strong>brands you've already worked with.</strong> Right now, brands
          are scrambling to lock in creators for BFCM and holiday campaigns. If
          you're top-of-mind, you win. That's why we're piloting a premium
          service where <strong>human writers</strong> handle your follow-ups —
          inside your existing brand threads — so you can secure repeat deals
          without lifting a finger.
        </Typography>
        <Typography variant="h6" sx={{ mt: 2 }}>
          Why This Matters
        </Typography>
        <ul>
          <li>
            ✅ Repeat clients = higher-value, easier deals (they know your rates
            + trust your content)
          </li>
          <li>
            ✅ Personalized, human-written replies - not generic templates
          </li>
          <li>
            ✅ Perfect timing: outreach before the end of September, aligned
            with brand planning cycles
          </li>
        </ul>
        <strong> Quick ROI barometer</strong>: Look at what you've already
        earned in 2024 - 2025. With re-activation, expect +10 - 20% more revenue
        this Q4.
        <Typography variant="h6" sx={{ mt: 2 }}>
          How It Works
        </Typography>
        <ol>
          <li> Pick a plan below</li>
          <li>We pull your past deals from 2024 - 2025</li>
          <li>
            Our writers draft follow-ups (you can review or stay hands-off)
          </li>
          <li>
            We send initial outreach{" "}
            <strong>
              plus up to 3 follow-ups automatically, spaced 4 business days
              apart
            </strong>
          </li>
        </ol>
        <Typography variant="h6" sx={{ mt: 2 }}>
          Pricing
        </Typography>
        <Typography sx={{ mb: 2 }}>
          Each brand thread includes:{" "}
          <strong>
            1 personalized outreach + up to 3 automatic follow-ups (≈4 emails
            total per brand)
          </strong>
          <br />
          <ul>
            <li>
              You choose how hands-on you want to be: approve drafts, or let us
              handle it end-to-end.{" "}
            </li>

            <li>
              Choose based on roughly how many brand deals you've had in the
              last 2 years
            </li>

            <li>
              You can pick the number of follow-ups that you would like us to
              send.
            </li>
          </ul>
        </Typography>
      </Grid>
      <Typography sx={{ color: "warning.main", fontWeight: 700 }}>
        <em>This program is no longer available.</em>
      </Typography>
    </Box>
  );
};

export default ProgramInfo;
